export const ECOMMERCE_URL = process.env.NEXT_PUBLIC_STORE_URL;
export const MEMBERSHIP_URL = process.env.NEXT_PUBLIC_STORE_MEMBERSHIP_URL;
